import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import React from "react";
import { Container } from "react-bootstrap";
import RequireAuth from "./components/auth/RequireAuth";
import RedirectToDashboard from "./components/RedirectToDashboard";
import RequireVendorAdmin from "./components/auth/RequireVendorAdmin";
import UnassignedBookings from "./components/UnassignedBookings";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

// Import components
import Dashboard from "./components/Dashboard";
import SubAdminDashboard from "./components/SubAdminDashboard";
import SubAdminLayout from "./components/SubAdminLayout";
import SubSubAdminLayout from "./components/SubSubAdminLayout";

import VendorDashboard from "./components/VendorDashboard";
import UserDashboard from "./components/UserDashboard";
import UserInfo from "./components/UserInfo";
import VendorInfo from "./components/VendorInfo";
import UserProfile from "./components/UserProfile";
import VendorProfile from "./components/VendorProfile";
import ReferFriends from "./components/ReferFriends";
import SubAdmin from "./components/SubAdmin";
import SubSubAdmin from "./components/SubSubAdmin";
import SubAdminSubSubAdmins from "./components/SubAdminSubSubAdmins";
import SubscriptionManagement from "./components/SubscriptionManagement";
import Subscribers from "./components/Subscribers";
import SubAdminSubscriptions from "./components/SubAdminSubscriptions";
import KYCVerification from "./components/KYCVerification";
import VendorVerificationRequests from "./components/VendorVerificationRequests";
import TransactionsManagement from "./components/TransactionsManagement";
import AdsManagement from "./components/AdsManagement";
import SurveysManagement from "./components/SurveysManagement";
import AdminGate from "./components/AdminGate";
import AdminLogin from "./components/AdminLogin";
import ProtectedLayout from "./components/ProtectedLayout";
import SubSubAdminDashboard from "./components/SubSubAdminDashboard";
import RepeatServiceAnalytics from "./components/RepeatServiceAnalytics";
import ChangeCredentials from "./components/ChangeCredentials";
import ResetPassword from "./components/ResetPassword";
import WithdrawalRequests from "./components/WithdrawalRequests";
import BookingsDashboard from "./components/BookingDashboard";
import DeleteUserAccount from "./components/Deleteuseraccount";
import PrivacyPolicy from "./components/Privacypolicy";
import AssignedBookings from "./components/AssignedBookings";
import TermsAndConditions from "./components/Termsandconditions";
import ComplaintsManagement from "./components/Complaintsmanagement";
import AdminCategoryManagement from "./components/AdminCategoryManagement";
import ApiSettingsManagement from "./components/ApiSettingsManagement";

function App() {
  return (
    <Router>
      <div className="App">
        <Container>
          <Routes>
            {/* Public routes */}
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/delete-account" element={<DeleteUserAccount />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsAndConditions />} />

            {/* Protected Admin Area */}
            <Route
              element={
                <RequireAuth>
                  <ProtectedLayout />
                </RequireAuth>
              }
            >
              {/* Admin */}
              <Route index element={<Dashboard />} />
              <Route path="api-settings" element={<ApiSettingsManagement />} />
              <Route
                path="vendor-dashboard"
                element={
                  <RequireVendorAdmin>
                    <VendorDashboard />
                  </RequireVendorAdmin>
                }
              />
              <Route path="bookings" element={<BookingsDashboard />} />
              <Route path="unassigned-bookings" element={<UnassignedBookings />} />
              <Route path="user-dashboard" element={<UserDashboard />} />
              <Route path="refer-friends" element={<ReferFriends />} />
              <Route path="sub-admins" element={<SubAdmin />} />
              <Route path="sub-sub-admins" element={<SubSubAdmin />} />
              <Route path="user-info/:id" element={<UserInfo />} />
              <Route path="user-profile/:id" element={<UserProfile />} />
              <Route path="categories" element={<AdminCategoryManagement />} />
              <Route
                path="vendor-info/:id"
                element={
                  <RequireVendorAdmin>
                    <VendorInfo />
                  </RequireVendorAdmin>
                }
              />
              <Route
                path="vendor-profile/:id"
                element={
                  <RequireVendorAdmin>
                    <VendorProfile />
                  </RequireVendorAdmin>
                }
              />
              <Route path="assigned-bookings" element={<AssignedBookings />} />
              <Route path="local-subscriptions" element={<SubAdminSubscriptions />} />
              <Route
                path="subscription-management"
                element={<SubscriptionManagement />}
              />
              <Route path="subscriptions" element={<Subscribers />} />
              <Route path="kyc-verification" element={<KYCVerification />} />
              <Route
                path="vendor-verification-requests"
                element={
                  <RequireVendorAdmin>
                    <VendorVerificationRequests />
                  </RequireVendorAdmin>
                }
              />
              <Route
                path="transactions-management"
                element={<TransactionsManagement />}
              />
              <Route path="ads-management" element={<AdsManagement />} />
              <Route
                path="complaints-management"
                element={<ComplaintsManagement />}
              />
              <Route
                path="surveys-management"
                element={<SurveysManagement />}
              />
              <Route
                path="repeat-service-analytics"
                element={<RepeatServiceAnalytics />}
              />
              <Route
                path="change-credentials"
                element={<ChangeCredentials />}
              />
              <Route
                path="withdrawal-requests"
                element={<WithdrawalRequests />}
              />

              {/* SubAdmin */}
              <Route path="subadmin/dashboard" element={<SubAdminDashboard />} />
              <Route path="subadmin/subsubadmins" element={<SubAdminSubSubAdmins />} />
              <Route path="subadmin/local-subscriptions" element={<SubAdminSubscriptions />} />
              <Route path="subadmin/ads-management" element={<AdsManagement />} />
              <Route path="subadmin/change-credentials" element={<ChangeCredentials />} />
              <Route path="subadmin/user-dashboard" element={<UserDashboard />} />
              <Route path="subadmin/vendor-dashboard" element={<VendorDashboard />} />
              <Route path="subadmin/transactions-management" element={<TransactionsManagement />} />
              <Route path="subadmin/withdrawal-requests" element={<WithdrawalRequests />} />
              <Route path="subadmin/bookings" element={<BookingsDashboard />} />
              <Route path="subadmin/repeat-service-analytics" element={<RepeatServiceAnalytics />} />

              {/* SubSubAdmin */}
              <Route path="subsubadmin/dashboard" element={<SubSubAdminDashboard />} />
              <Route path="subsubadmin/change-credentials" element={<ChangeCredentials />} />
              <Route path="subsubadmin/user-dashboard" element={<UserDashboard />} />
              <Route path="subsubadmin/vendor-dashboard" element={<VendorDashboard />} />
              <Route path="subsubadmin/bookings" element={<BookingsDashboard />} />

              {/* Catch ALL unknown routes */}
              <Route path="*" element={<RedirectToDashboard />} />
            </Route>

            {/* Absolute fallback */}
            <Route path="*" element={<Navigate to="/admin" replace />} />
          </Routes>
        </Container>
      </div>
    </Router>
  );
}

export default App;
